// extracted by mini-css-extract-plugin
module.exports = {"container":"SystemProfile_container__1Op5N","title":"SystemProfile_title__J2R9k","link":"SystemProfile_link__1zBn4"};